
const Module = () => import('./ProgramModule.vue');

const setBreadcrumbs = (to, from) => {
    let breadcrumbs = [];

    if (from.name == 'organizations' && to.name == 'organization') {
        breadcrumbs.push({ label: 'Registered Organizations', route: '/program/organizations/' });
        breadcrumbs.push({ label: to.meta.title });
    } else if (from.name == 'registrationapprovals' && to.name == 'organization') {
        breadcrumbs.push({ label: 'Registration Approvals', route: '/program/registrationapprovals/' });
        breadcrumbs.push({ label: to.meta.title });
    } else {
        breadcrumbs = to.meta.breadcrumb;
    }

    return breadcrumbs;
};

const filterPath = (to, from, next) => {
    if (to.fullPath !== to.path) {
        to.meta.breadcrumb = setBreadcrumbs(to, from);
        next({ path: to.path });
    } else {
        to.meta.breadcrumb = setBreadcrumbs(to, from);
        next();
    }
};

const moduleRoutes = 
    {
        path: '/program',
        component: Module,
        children: [
            {
                path: 'organizations',
                name: 'organizations',
                meta: {
                    title: 'Registered Organizations',
                    requiresAuth: true,
                    requiresAdmin: true,
                    instructions: 'Below are a list of organizations that have registered and been approved to participate in the program.',
                    breadcrumb: [
                        { label: 'Registered Organizations' }
                    ]
                },
                component: () => import('./views/OrganizationsView.vue'),
                beforeEnter: filterPath
            },
            {
                path: 'registrationapprovals',
                name: 'registrationapprovals',
                meta: {
                    title: 'Registration Approvals',
                    requiresAuth: true,
                    requiresAdmin: true,
                    instructions: 'Below are a list of pending registration approvals.',
                    breadcrumb: [
                        { label: 'Registration Approvals'}
                    ]
                },
                component: () => import('./views/RegistrationApprovalsView.vue'),
                beforeEnter: filterPath
            },
            {
                path: 'organization/:id',
                name: 'organization',
                meta: {
                    title: 'Organization',
                    requiresAuth: true,
                    requiresAdmin: true,
                    instructions: '',
                    // breadcrumb: [
                    //     { label: 'Organization' }
                    // ]
                    // breadcrumb:  [
                    //     { label: 'Home', to: { path: '/' } },
                    //     { label: 'Registered Organizations', route: 'program/organizations' },
                    //     { label: 'Organization' }
                    // ]
                },
                component: () => import('./views/OrganizationView.vue'),
                beforeEnter: filterPath
            },
            {
                path: 'mydepartment',
                name: 'mydepartment',
                meta: {
                    title: 'My Department',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'My Department' }
                    ]
                },
                component: () => import('./views/MyDepartmentView.vue'),
                beforeEnter: filterPath
            },
            {
                path: 'department/:id',
                name: 'department',
                meta: {
                    title: 'Department',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Department' }
                    ]
                },
            },
            {
                path: 'hpannualreport/:reportId',
                name: 'hpannualreport',
                props: true,
                meta: {
                    title: 'HP Annual Report',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Review Annual Reports', route: '/program/annualreports' },
                        { label: 'HP Annual Report' }
                    ]
                },
                component: () => import('./views/HpAnnualReportView.vue'),
                beforeEnter: filterPath
            },
            {
                path: 'annualreports',
                name: 'programannualreports',
                meta: {
                    title: 'Review Annual Reports',
                    instructions: 'Select a report year and report type to view the annual reports.',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Review Annual Reports' }
                    ]
                },
                component: () => import('./views/ProgramAnnualReportsView.vue'),
                beforeEnter: filterPath
            },
            {
                path: 'programHces',
                name: 'programHces',
                meta: {
                    title: 'Review HCE Transactions',
                    requiresAuth: true,
                    requiresAdmin: true,
                    breadcrumb: [
                        { label: 'Review HCE Transactions' }
                    ]
                },
                component: () => import('./views/ProgramHceView.vue'),
                beforeEnter: filterPath
            },
            {
                path: 'transaction/:id',
                name: 'edittransaction',
                props: true,
                meta: {
                    title: 'Health Care Entity Transaction',
                    requiresAuth: true,
                    breadcrumb: [
                        { label: 'Review HCE Transactions', route: '/program/programHces' },
                        { label: 'Health Care Entity Transaction' }
                    ]
                },
                component: () => import('../hcet/views/HceTransactionView.vue'),
                beforeEnter: filterPath
            }   
        ]
    };

export default router => {
    router.addRoute(moduleRoutes);
};